export default {
  createSuccess: "Struttura creata con successo!",
  updated: "Struttura aggiornata!",
  deviceNameEmpty: "Il nome stanza non può essere vuoto",
  deviceRenamed: "Stanza aggiornata",
  changeRoomTitle: "Cambia stanza",
  addRoomTitle: "Aggiungi stanza",
  changeRoomCurrentLabel: "Stanza attuale",
  changeRoomNewLabel: "Nuovo nome stanza",
  changeRoomPlaceholder: "es. 231H",
  changeRoomNoRoom: "Nessuna stanza",
  changeRoomUnchanged: "Inserisci un nome diverso per continuare",
  changeRoomConfirm: "Continua",
  changeRoomRemove: "Rimuovi stanza",
  adminRenameConfirmTitle: "Cambiare stanza?",
  adminRenameConfirmMessage:
    'La stanza «{{name}}» aiuta gli host a riconoscere i tablet. Modificarla senza il loro consenso può creare confusione. Puoi procedere comunque se necessario.',
  roomChangeTitle: "Cambiare stanza?",
  roomChangeIntro:
    "Questo tablet ha ospiti attuali o futuri. Scegli cosa farne.",
  roomChangeNewLabel: "Nuova stanza:",
  roomChangeCurrentHeading: "Ospiti attuali",
  roomChangeFutureHeading: "Ospiti futuri",
  roomChangeTransferHelp:
    "Trasferisci: mantieni gli ospiti su questo tablet con il nuovo nome stanza.",
  roomChangeDiscardHelp:
    "Scarta: termina gli ospiti attuali (cronologia conservata) ed elimina i soggiorni futuri.",
  roomChangeTransfer: "Trasferisci ospiti",
  roomChangeDiscard: "Scarta occupazione",
  structureLeaveIntro:
    'Rimuovendo l’assegnazione da «{{name}}» verrà cancellata l’occupazione attiva di questo tablet.',
  structureLeaveCurrentHeading:
    "Ospiti attuali (soggiorno terminato, resta in cronologia)",
  structureLeaveFutureHeading: "Ospiti futuri (eliminati del tutto)",
  structureLeaveCurrentNote:
    "I soggiorni attuali terminano ora e restano nella cronologia di questa struttura.",
  structureLeaveFutureNote:
    "I soggiorni futuri vengono rimossi e non possono essere ripristinati.",
  structureLeaveEmpty: "Nessun ospite attuale o futuro su questo tablet.",
  structureLeaveLoading: "Controllo ospiti…",
  credentialsRegenerated: "Credenziali rigenerate",
  createModal: {
    title: "Aggiungi struttura",
    houseNameLabel: "Nome struttura *",
    houseNamePlaceholder: "es. Villa Sunset",
    addressRequired: "Inserisci l’indirizzo della struttura.",
    commissionPercentLabel: "Quota host per ogni prenotazione (%)",
    nameRequired: "Inserisci il nome della struttura.",
    commissionPercentRange: "Inserisci una percentuale valida.",
    salesAgent: "Agente di commercio (contratto)",
    salesAgentSearchPlaceholder: "Digita un’email…",
    salesAgentNoResults: "Nessun agente corrisponde alla ricerca.",
    salesAgentListEmpty: "Nessun agente disponibile.",
    wizardStep2Lead:
      "Seleziona un agente dall’elenco, o salta per continuare senza.",
    salesAgentCutPercentLabel: "Commissione agente (%)",
    salesAgentCutRequired:
      "Inserisci la commissione dell’agente quando ne selezioni uno.",
    wizardStep3Lead: "Inserisci l’indirizzo completo della struttura.",
    wizardNext: "Continua",
    wizardSkip: "Salta",
    create: "Crea struttura",
  },
  adminCreate: {
    back: "Torna alle strutture",
    backToHost: "Torna all'host",
  },
  list: {
    openHouse: "Apri",
    hostIdMissing: "ID host non trovato. Accedi come host.",
    titleAdminNoHosts: "Strutture",
    subtitleAdminNoHosts:
      "Crea prima un host, poi potrai aggiungere strutture.",
    emptyHosts: "Nessun host registrato. Aggiungili dalla sezione Host.",
    titleByHost: "Strutture per host",
    titleMy: "Le mie strutture",
    subtitleByHost: "Scegli un host e gestisci le sue strutture",
    subtitleMy:
      "Visualizza le strutture assegnate al tuo account e gestisci i tablet",
    hostLabel: "Host",
    selectHostAria: "Seleziona host",
    addHouse: "Aggiungi struttura",
    emptyTitle: "Nessuna struttura ancora",
    emptyDescAdmin: "Aggiungi una struttura per questo host.",
    emptyDescHost: "Lo staff creerà le strutture per il tuo account.",
    addFirstHouse: "Aggiungi prima struttura",
    loading: "Caricamento strutture…",
    active: "Attiva",
    inactive: "Inattiva",
    commissionRate: "{{percent}}% quota host",
    hostOptionLabel: "{{name}} (host)",
  },
  detail: {
    createdOn: "Creata il {{date}}",
    overview: {
      devices: "Tablet",
      devicesHint: "Assegnati a questa struttura",
      devicesOnline_one: "{{count}} online",
      devicesOnline_other: "{{count}} online",
      guestsNow: "Ospiti ora",
      guestsNowHint: "Tablet occupati su {{count}}",
      upcoming: "Arrivi in coda",
      upcomingHint: "Soggiorni futuri sui tablet",
      hostShare: "Quota host",
      hostShareHint: "Su ogni prenotazione fatta dai tablet della struttura",
    },
    settings: {
      visibilityTitle: "Visibilità",
    },
    notFoundMessage:
      "Questa struttura potrebbe essere stata rimossa o non hai accesso.",
    loading: "Caricamento struttura…",
    back: "Torna alle strutture",
    backToHouses: "Torna alle strutture",
    goToPartner: "Vai al partner",
    partnerLabel: "Partner",
    tabs: {
      settings: "Impostazioni",
      ariaLabel: "Sezioni configurazione struttura",
      devices: "Dispositivi",
      devicesHintAdmin:
        "Assegna i tablet a questa struttura, collega i lettori di pagamento e gestisci le credenziali dei dispositivi.",
      presences: "Presenze",
    },
    presences: {
      staysTitle: "Soggiorni",
      segmentCurrent: "In corso ({{count}})",
      segmentUpcoming: "In arrivo ({{count}})",
      segmentAria: "Vista soggiorni",
      currentHint:
        "Ospiti attualmente assegnati ai tablet di questa struttura, come registrato dall'host.",
      upcomingHint:
        "Ospiti con arrivo programmato sui tablet di questa struttura, inclusi i soggiorni importati da PDF.",
      historyHeading: "Occupazione storica",
      historyHint:
        "L'occupazione è calcolata come tempo occupato dei dispositivi diviso per la capacità totale dei dispositivi nel periodo selezionato.",
      loadingHistory: "Caricamento presenze del periodo…",
      errorConnectionMessage: "Controlla la connessione o i permessi e riprova.",
      errorHistoryTitle: "Impossibile caricare le presenze del periodo",
      emptyCurrentMessage:
        "Nessun tablet di questa struttura ha un ospite attivo al momento.",
      emptyUpcomingMessage:
        "Nessun soggiorno in arrivo è programmato per questa struttura.",
      emptyHistoryMessage:
        "Nessuna presenza si sovrappone al periodo selezionato.",
      colDevice: "Dispositivo",
      colNationality: "Nazionalità",
      colMarketing: "Marketing",
      colGuests: "Ospiti",
      colContacts: "Contatti",
      copyContactHint: "Clicca per copiare",
      guestsWithCount: "{{name}} (x{{count}})",
      childrenBadgeHint: "Ci sono bambini in questo soggiorno",
      colArrival: "Arrivo",
      colDeparture: "Partenza",
      colNotes: "Note",
      notesAria: "Visualizza note ospite",
      colActions: "Azioni",
      editAction: "Modifica presenza",
      deleteAction: "Rimuovi presenza",
      editModalTitle: "Modifica presenza – {{deviceName}}",
      consentMarketing: "Marketing diretto",
      consentProfiling: "Profilazione",
      consentThirdParty: "Marketing di terze parti",
      consentGrantedHint: "L'ospite ha dato consenso per:",
      consentDeniedHint: "L'ospite non ha dato alcun consenso marketing.",
      valueUnknown: "—",
      genericGuestName: "Ospite",
      dateFrom: "Da",
      dateTo: "A",
      applyRange: "Applica",
      resetRange: "Ultimi 3 mesi",
      metricOccupancy: "Occupazione",
      metricOccupancyHint:
        "Occupazione media dei tablet nel periodo selezionato",
      metricDevices: "Dispositivi",
      metricPresences: "Presenze",
      chartHeading: "Occupazione giornaliera",
      chartAria:
        "Grafico dell'occupazione giornaliera per il periodo selezionato",
      periodTableHeading: "Presenze nel periodo",
      periodTableHint: "Soggiorni che si sovrappongono al periodo selezionato.",
      currentIndicatorHint: "Questa presenza è attualmente attiva.",
      emptyPeriodMessage:
        "Nessuna presenza si sovrappone al periodo selezionato.",
    },
    presenceImport: {
      title: "Importa presenze da PDF",
      adminOnly: "Solo staff",
      barHint:
        "Estrai soggiorni da un PDF (anche scansionato), poi revisiona i campi obbligatori.",
      open: "Importa PDF",
      hint: "Carica qualsiasi PDF di occupazione: elenchi ospiti, export PMS o scansioni. Compila i campi obbligatori vuoti e salva.",
      fileLabel: "Solo PDF",
      dropHint: "Clicca per scegliere un PDF",
      extract: "Estrai soggiorni",
      save: "Salva presenze",
      cancel: "Annulla",
      chooseAnother: "Scegli un altro PDF",
      addRow: "Aggiungi soggiorno",
      previewCount: "{{count}} soggiorni da revisionare",
      colDevice: "Dispositivo",
      colGuest: "Nome ospite",
      colNationality: "Nazionalità",
      colArrival: "Arrivo",
      colDeparture: "Partenza",
      devicePlaceholder: "Seleziona dispositivo",
      unmatchedHint: "Dal PDF: {{room}}",
      removeRow: "Rimuovi soggiorno",
      pickFile: "Seleziona prima un file PDF.",
      emptyPreview: "Nessun soggiorno da salvare. Estrai di nuovo o annulla.",
      toastExtracted:
        "Estratti {{count}} soggiorni. Revisiona prima di salvare.",
      toastSaved: "Salvate {{count}} presenze.",
      undo: "Annulla modifica",
      discardConfirmTitle: "Scartare il lavoro?",
      discardConfirmMessage:
        "Se continui senza salvare, perderai le modifiche alle presenze estratte.",
      discardConfirmAction: "Scarta e continua",
      discardConfirmCancel: "Resta qui",
      extractingHint: "Analisi del PDF in corso…",
      fileSelectedHint: "PDF selezionato — clicca per sceglierne un altro",
      unassignedBanner:
        "{{count}} soggiorno/i senza tablet. Assegna ogni soggiorno prima di salvare.",
      unassignedDeviceError: "Assegna un tablet",
      unassignedDeviceTitle: "Nessun tablet assegnato",
      assignedDeviceTitle: "Tablet assegnato",
      scheduleHint: "Orari predefiniti: check-in ~15:00 · check-out ~10:00",
      invalidDateRange: "Partenza prima dell'arrivo",
    },
    visibilityLabel: "Struttura attiva",
    visibilityHint:
      "Le strutture inattive sono nascoste nei flussi dell'host finché non vengono riattivate.",
    visibilityToggleAria: "Attiva o disattiva questa struttura",
    devicesTitle: "Dispositivi ({{count}})",
    noDevices: "Nessun dispositivo in questa struttura",
    noDevicesHint:
      "Lo staff può creare dispositivi nella sezione Dispositivi e assegnarli qui.",
    deviceNamePlaceholder: "Nome stanza",
    renameDeviceTitle: "Cambia stanza",
    kioskCode: "Codice dispositivo",
    serialLabel: "S/N",
    currentGuest: "Ospite attuale",
    guestDeparts: "parte il {{date}}",
    statusRevoked: "Revocato",
    statusCreated: "Creato",
    statusActive: "Attivo",
    regenerateConfirm:
      "Rigenerare la password di «{{name}}»? Le sessioni tablet esistenti non saranno più valide.",
    credentialModalTitle: "Credenziali rigenerate",
    credentialModalDesc:
      "La password è stata rigenerata. Salva subito queste credenziali: la password viene mostrata una sola volta.",
    managePresences: "Gestisci ospiti",
    addPresences: "Inserisci ospiti",
    noGuestPresence: "Nessun ospite inserito",
    queuedGuests: "{{count}} in coda",
    queuedGuests_one: "1 in coda",
    noCurrentGuestWithQueue: "Nessun ospite attuale · {{count}} in coda",
    noCurrentGuestWithQueue_one: "Nessun ospite attuale · 1 in coda",
    refreshCredentials: "Aggiorna credenziali",
    refreshingCredentials: "Aggiornamento…",
    hostDevicesCaption:
      "Codici di accesso e dettagli tecnici sono gestiti dallo staff. Puoi assegnare un nome a ogni tablet, trascinarli per riordinarli e registrare gli ospiti.",
    dragToReorder: "Trascina per riordinare",
    modalHouseName: "Nome struttura",
  },
  adminDetail: {
    houseName: "Nome struttura",
    placeholderHouseName: "es. Villa Spiaggia",
    locationTitle: "Indirizzo",
    commissionSettings: "Quota host",
    commissionPct: "Quota host per ogni prenotazione (%)",
    commissionPlaceholder: "es. 5",
    assignDevice: "Assegna dispositivo",
    assignDeviceCta: "Assegna un dispositivo",
    colDevice: "Stanza",
    colSerial: "S/N",
    colGoogleAccount: "Account Google",
    colFreekioskUnlock: "Sblocco FK",
    colReader: "Lettore",
    colLastTelemetry: "Ultima telemetria",
    colLastInteraction: "Ultima interazione",
    colInstalledOn: "Installato il",
    colAppVersion: "Versione app",
    colInUse: "In campo",
    colActions: "Azioni",
    renameDeviceTitle: "Cambia stanza",
    changeRoomTitle: "Cambia stanza",
    roomNamePlaceholder: "Nome stanza",
    roomNameEmpty: "Il nome stanza non può essere vuoto",
    editGoogleAccountTitle: "Modifica account Google",
    editNotesTitle: "Note",
    editInstalledOnTitle: "Data di installazione",
    insertInstalledOn: "Inserisci data",
    notesPlaceholder: "Aggiungi una nota…",
    moreActionsTitle: "Altre azioni",
    readerPair: "Collega",
    readerOpenTitle: "Vai al lettore",
    readerUnpairTitle: "Scollega lettore",
    readerUnpairConfirm:
      "Scollegare questo lettore dal tablet? L'abbinamento SumUp rimane; i pagamenti resteranno disabilitati finché non lo colleghi di nuovo.",
    readerUnpaired: "Lettore scollegato",
    unassignDeviceTitle: "Rimuovi assegnazione",
    menuRegenerateCredentials: "Rigenera credenziali",
    menuRevokeDevice: "Revoca credenziali",
    menuReactivateDevice: "Riattiva credenziali",
    menuManagePresences: "Gestisci ospiti",
    menuNotes: "Note",
    menuOtherInfo: "Altre informazioni",
    toastAssignSuccess: "Dispositivo assegnato con successo!",
    toastUpdateSuccess: "Struttura aggiornata con successo!",
    toastReaderUpdated: "Lettore aggiornato",
    toastDeviceRevoked: "Dispositivo revocato",
    toastDeviceReactivated: "Dispositivo riattivato",
    toastDeviceShelved: "Dispositivo in magazzino",
    toastDeviceUnshelved: "Dispositivo rimesso in campo",
    toastDeviceUnassigned: "Dispositivo rimosso dalla struttura",
    toastDeviceRenamed: "Stanza aggiornata",
    toastGoogleAccountUpdated: "Account Google aggiornato",
    toastNotesUpdated: "Note aggiornate",
    toastInstalledOnUpdated: "Data di installazione aggiornata",
    unassignConfirm: "Rimuovere «{{name}}» da questa struttura?",
    assignModalTitle: "Assegna dispositivo alla struttura",
    assignModalIntro: "Seleziona un dispositivo da assegnare a {{houseName}}:",
    searchDevicesLabel: "Cerca dispositivi",
    filterDevicesPlaceholder: "Nome, codice o seriale…",
    searchDevicesPlaceholder:
      "Cerca per stanza, codice o numero di serie…",
    assignModalNoResultsSearch: "Nessun dispositivo corrisponde a «{{query}}».",
    assignModalNoResults: "Nessun dispositivo disponibile da assegnare.",
    assign: "Assegna",
    deviceListMeta: "{{code}} — S/N: {{serial}}",
    otherInfoTitle: "Altre informazioni sul dispositivo",
    fieldRoomName: "Stanza",
    fieldKioskCode: "Codice dispositivo",
    fieldSerialNumber: "Numero di serie",
    fieldGoogleAccount: "Account Google",
    fieldSoftwareId: "ID software",
    fieldReaderId: "ID lettore",
    fieldBrand: "Marca",
    fieldDisplayInches: "Pollici display",
    fieldResolution: "Risoluzione",
    fieldAndroidVersion: "Versione Android",
    fieldAppVersion: "Versione app",
    valueAppVersionUnknown: "Sconosciuta",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    fieldLastTelemetryReport: "Ultima telemetria ricevuta",
    sectionTelemetryData: "Dati telemetria",
    sectionTelemetryDeviceStatus: "Stato dispositivo (FreeKiosk)",
    sectionTelemetryGpsLocation: "Posizione (GPS del dispositivo)",
    valueTelemetryNever: "Mai",
    valueTelemetryEmpty: "Nessun dato ancora",
    valueUnbound: "Non associato",
    valueNotPaired: "Non collegato",
    telemetryBattery: "Batteria",
    telemetryWifi: "Segnale WiFi",
    telemetryAudio: "Volume audio",
    telemetryStorage: "Archivio usato",
    telemetryMemory: "RAM usata",
    telemetryUnavailable: "-",
    telemetryDataAge: "Dati di {{age}}",
  },
  kioskPresence: {
    modalTitle: "Ospiti – {{kioskName}}",
    tabletFallback: "Tablet",
    toastAdded: "Ospite registrato",
    toastUpdated: "Ospite aggiornato",
    toastDeleted: "Ospite eliminato",
    errorGuestNameRequired: "Il nome dell’ospite è obbligatorio",
    errorNationalityRequired: "La nazionalità è obbligatoria",
    errorDatesRequired: "Le date di arrivo e partenza sono obbligatorie",
    errorDepartureDateRequired: "La data di partenza è obbligatoria",
    errorDepartureAfterArrival: "La partenza deve essere successiva all’arrivo",
    deleteConfirm: "Eliminare l’ospite «{{guestName}}»?",
    replaceCurrentTitle: "Terminare il soggiorno dell’ospite attuale?",
    replaceCurrentMessage:
      "{{guestName}} è attualmente registrato su questo tablet. Per registrare un nuovo ospite, termineremo il soggiorno attuale ora e avvieremo quello nuovo.",
    replaceCurrentConfirm: "Termina soggiorno e registra nuovo ospite",
    sectionCurrentGuest: "Ospite attuale",
    sectionUpcoming: "Nuovo ospite",
    emptyNoCurrentGuest: "Nessun ospite attuale",
    emptyNoUpcoming: "Nessun ospite registrato",
    ctaAddPresence: "Aggiungi ospite",
    labelGuestName: "Nome ospite",
    labelGuestLastName: "Cognome",
    labelGuestEmail: "Email",
    labelGuestPhone: "Telefono",
    labelNationality: "Nazionalità",
    labelArrivalDate: "Data di arrivo",
    labelArrivalTime: "Ora di arrivo",
    labelDepartureDate: "Data di partenza",
    labelDepartureTime: "Ora di partenza",
    scheduleLaterArrival: "L'ospite arriva in un'altra data",
    scheduleLaterArrivalHint:
      "Lascia deselezionato per registrare da adesso. Attiva per mettere in coda un soggiorno futuro su questo tablet.",
    labelPeople: "Persone",
    labelChildrenCheckbox: "Bambini",
    labelNotes: "Note",
    childrenBadge: "Bambini",
    placeholderGuestName: "es. Mario",
    placeholderGuestLastName: "es. Rossi",
    placeholderGuestEmail: "es. mario.rossi@email.com",
    placeholderGuestPhone: "es. +393331234567",
    placeholderNationality: "es. Italia",
    placeholderNotes: "Note facoltative...",
    peopleCount_one: "{{count}} persona",
    peopleCount_other: "{{count}} persone",
    buttonAddPresence: "Registra ospite",
    buttonUpdatePresence: "Aggiorna ospite",
    consentSectionTitle: "Modulo di consenso",
    consentSectionHint:
      "I dati personali (email, telefono) vengono salvati solo se l’ospite acconsente ad almeno una delle opzioni sotto.",
    consentMarketing:
      "ACCONSENTO al trattamento dei miei dati personali da parte di Guestify Italia S.r.l. per l'invio di comunicazioni di marketing, newsletter e offerte commerciali.",
    consentProfiling:
      "ACCONSENTO al trattamento dei miei dati personali da parte di Guestify Italia S.r.l. per analizzare le mie preferenze e ricevere offerte e servizi personalizzati.",
    consentThirdParty:
      "ACCONSENTO al trasferimento dei miei dati personali da parte di Guestify Italia S.r.l. a suoi partner selezionati per finalità di marketing.",
    consentRecordedBadge: "Consenso registrato",
  },
} as const;
